import { Controller } from "@hotwired/stimulus";
import { Tooltip } from "bootstrap";

// Members controller for dynamic member fields on membership forms
export default class extends Controller {
  static targets = ["container", "template", "entry"];

  add(event) {
    event.preventDefault();

    const content = this.templateTarget.innerHTML;
    const index = Date.now();
    const newEntry = content.replace(/NEW_INDEX/g, index);

    this.containerTarget.insertAdjacentHTML("beforeend", newEntry);

    const lastEntry = this.containerTarget.lastElementChild;
    lastEntry
      .querySelectorAll('[data-bs-toggle="tooltip"]')
      .forEach((el) => new Tooltip(el));
  }

  remove(event) {
    event.preventDefault();

    const entry = this.entryTargets.find((el) => el.contains(event.target));
    if (entry) {
      entry.remove();
    }
  }
}
